import { Component, OnInit, ChangeDetectionStrategy, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { PFieldAbstractComponent } from '../p-field-abstract';

@Component({
    selector: 'p-field-static-progress-bar',
    template: ` <p-field [label]="label" [isReadOnly]="true">
        <p-static-progress-bar
            slot="readMode"
            [value]="value"
            [label]="value + '%'"
            [matTooltip]="valueTooltip"
            [isLink]="isLink"
            (linkClicked)="linkClicked.emit()"
        ></p-static-progress-bar>
    </p-field>`,
    styleUrls: ['./p-field-static-progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PFieldStaticProgressBarComponent
        }
    ]
})
export class PFieldStaticProgressBarComponent extends PFieldAbstractComponent<number> {
    @Input() label?: string;
    @Input() isLink = false;
    @Input() override valueTooltip: string = '';
    @Output() linkClicked = new EventEmitter();

    constructor(cd: ChangeDetectorRef) {
        super(cd);
    }
}
